import _ from "lodash";
import {
  goToPlatformHomeChildRoute,
  goToProjectFeatureRouteByProjectGroupType,
} from "modules/NavigationModule";
import { goToMessagingV2Route } from "MessagingV2/modules/MessagingModule";

import { getUserRegions, isGlobalUser } from "Courses/modules/utils";
import { setupCurriculumProgramDependencies } from "Platform/modules/PlatformModule";

import { getOrganizationDetailsFromCache } from "modules/CommonGraphqlHelpers";

import {
  setCurrentPageTitle,
  getUserInfo,
  authorizeUserWithOauth2,
  authorizeUserWithEsfSentral,
} from "Login/modules/LoginModule";
import { setSelectedCourseId } from "Teacher/routes/PortfolioReview/modules/PortfolioReviewModule";

import {
  recordMessagingModuleOpened,
  MESSAGING_MODULE_OPENED_FROM,
} from "MessagingV2/modules/Utils";

import {
  PROJECT_GROUP_TYPE_DP_CAS,
  PROJECT_GROUP_TYPE_DP_TOK_ESSAY,
  PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION,
  PROJECT_GROUP_TYPE_DP_EE,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_COMMUNITY,
  PROJECT_GROUP_TYPE_SERVICE_AS_ACTON,
  PROJECT_GROUP_TYPE_DP_G4_PROJECT,
  PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT,
  PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT,
  PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING,
  PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT,
} from "Projects/Constants/stringConstants";

import {
  HOME_PAGE_FEATURE_ANNOUNCEMENT,
  HOME_PAGE_FEATURE_ATTENDANCE,
  HOME_PAGE_FEATURE_CALENDAR,
  HOME_PAGE_FEATURE_COURSES,
  HOME_PAGE_FEATURE_CLASSROOM_TODO,
  HOME_PAGE_FEATURE_FAMILY_COMMUNICATION,
  HOME_PAGE_FEATURE_GOALS,
  HOME_PAGE_FEATURE_LEARNER_PORTFOLIO,
  HOME_PAGE_FEATURE_MESSAGING,
  HOME_PAGE_FEATURE_PROGRESS_REPORT,
  HOME_PAGE_FEATURE_SNP,
  HOME_PAGE_FEATURE_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_DP_SUBJECT_CENTER,
  HOME_PAGE_FEATURE_TODDLE_ANALYTICS,
  HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT,
  HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER,
  HOME_PAGE_FEATURE_MB_LIBRARY,
  HOME_PAGE_FEATURE_MB_CONTENT_SKILLS,
  HOME_PAGE_FEATURE_MB_PUBLISH_UNIT,
  HOME_PAGE_FEATURE_HOMEROOM,
  HOME_PAGE_PORTFOLIO_REVIEW,
  HOME_PAGE_FEATURE_SCHOOL_LIBRARY,
  HOME_PAGE_FEATURE_TIMETABLE,
  HOME_PAGE_FEATURE_TIMETABLE_MANAGER,
  HOME_PAGE_FEATURE_OAUTH_LOGIN,
  HOME_PAGE_FEATURE_MCGRAW_HILL_LTI,
  ESF_SENTRAL_ATTENDANCE,
  ESF_SENTRAL_POLICIES,
  ESF_SENTRAL_WELLBEING,
  ESF_SENTRAL_TIMETABLE,
  HOME_PAGE_FEATURE_PLANNING_INSIGHTS,
  HOME_PAGE_FEATURE_GRADEBOOK,
  ESF_SENTRAL_PXP,
  ESF_SENTRAL_NEWSFEED,
  ESF_SENTRAL_DAILY_NOTICE,
  HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS,
  HOME_PAGE_FEATURE_CURRICULUM_MAPS,
  HOME_PAGE_FEATURE_STUDENT_PLANS,
} from "../Constants";
import { getCurrentCurriculumContextForJumpTo } from "modules/CommonSelectors";
import { getOauthServiceName } from "./GraphqlHelpers";

const _getManageUnitPublishRoute = ({ userTags }) => {
  const regionTags = getUserRegions({ userTags });
  return isGlobalUser({ userTags }) || regionTags.length > 1
    ? "unit-publishing"
    : `unit-publishing/${regionTags[0].id}_${regionTags[0].value}`;
};

export const navigateToFeature = ({
  feature,
  t,
  allowCrossCurriculumNavigation = false,
  isSentralNotificationActive = false,
  currentCurriculumProgramId = null,
  appendCurriculumIdInQueryParam = false,
}) => {
  return (dispatch, getState) => {
    const state = getState();
    if (allowCrossCurriculumNavigation) {
      // User can go to cross curriculum courses from jumpTo section inside global search modal
      const platformCurriculumContext = _.get(
        state,
        "platform.currentCurriculumProgram"
      );

      const platformCurriculumId = _.get(platformCurriculumContext, "id");

      const globalSearchCurriculumContext = getCurrentCurriculumContextForJumpTo(
        state
      );

      const globalSearchCurriculumId = _.get(
        globalSearchCurriculumContext,
        "id"
      );

      if (
        globalSearchCurriculumContext &&
        platformCurriculumId != globalSearchCurriculumId
      ) {
        dispatch(
          setupCurriculumProgramDependencies({
            curriculumProgramIdPath: globalSearchCurriculumId,
          })
        );
      }
    }

    switch (feature) {
      case HOME_PAGE_FEATURE_ANNOUNCEMENT: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "circulars",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_MCGRAW_HILL_LTI: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "lti-tools/mcgrawhill",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_ATTENDANCE: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "attendance-dashboard",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_TIMETABLE: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "teacher-timetable",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_TIMETABLE_MANAGER: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "timetable-manager",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_CLASSROOM_TODO: {
        dispatch(goToPlatformHomeChildRoute({ route: "class-stream-manager" }));
        break;
      }
      case HOME_PAGE_PORTFOLIO_REVIEW: {
        dispatch(setSelectedCourseId(null));
        dispatch(
          goToPlatformHomeChildRoute({
            route: "portfolio-review",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_CALENDAR: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "courses/my-calendar",
          })
        );
        break;
      }
      case HOME_PAGE_FEATURE_COURSES: {
        dispatch(goToPlatformHomeChildRoute({ route: "learning-courses" }));
        break;
      }
      case HOME_PAGE_FEATURE_FAMILY_COMMUNICATION: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "familyconversations",
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_MESSAGING: {
        dispatch(goToMessagingV2Route());
        recordMessagingModuleOpened({
          from: MESSAGING_MODULE_OPENED_FROM.DASHBOARD, //Discuss with messaging team
        });
        break;
      }

      case HOME_PAGE_FEATURE_PROGRESS_REPORT: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "progress-report-sets",
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_SNP: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "snp_v2",
            curriculumProgramId: currentCurriculumProgramId,
            appendCurriculumIdInQueryParam,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_LEARNER_PORTFOLIO: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: "learner-portfolio",
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_EDUCATOR_CENTER: {
        dispatch(goToPlatformHomeChildRoute({ route: "educatorcenter_v2" }));
        break;
      }

      case HOME_PAGE_FEATURE_GOALS: {
        dispatch(goToPlatformHomeChildRoute({ route: "goals" }));
        break;
      }

      case HOME_PAGE_FEATURE_MB_LIBRARY: {
        const userInfo = getUserInfo();
        const { org_id: organizationId } = userInfo;

        const organizationDetails = getOrganizationDetailsFromCache(
          organizationId
        );

        const centralRepoCourseId = _.get(
          organizationDetails,
          "repoOrganization.commonCourseId",
          ""
        );

        dispatch(
          setCurrentPageTitle({
            from: "home-page",
            label: `MB ${t("common:library")}`,
          })
        );
        dispatch(
          goToPlatformHomeChildRoute({
            route: `courses/${centralRepoCourseId}`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_HOMEROOM: {
        const homeRoomRoute = "homeroom";
        dispatch(goToPlatformHomeChildRoute({ route: homeRoomRoute }));
        break;
      }

      case HOME_PAGE_FEATURE_DP_SUBJECT_CENTER: {
        dispatch(
          setCurrentPageTitle({
            from: "home-page",
            label: t("common:subject_center"),
          })
        );
        dispatch(
          goToPlatformHomeChildRoute({
            route: "subject-center",
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_TODDLE_ANALYTICS: {
        dispatch(goToPlatformHomeChildRoute({ route: "toddle-insights" }));
        break;
      }

      case HOME_PAGE_FEATURE_BEHAVIOR_MANAGEMENT: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: `behaviour-management`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_MB_EDUCATOR_CENTER: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: `educatorcenter`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_MB_CONTENT_SKILLS: {
        dispatch(
          setCurrentPageTitle({
            from: "home-page",
            label: t("common:benchmarks_label"),
          })
        );
        dispatch(
          goToPlatformHomeChildRoute({
            route: "content-skills/scopeandsequence",
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_MB_PUBLISH_UNIT: {
        const userInfo = getUserInfo();
        const { tags: userTags } = userInfo;

        dispatch(
          goToPlatformHomeChildRoute({
            route: _getManageUnitPublishRoute({ userTags }),
          })
        );
        break;
      }

      case PROJECT_GROUP_TYPE_DP_CAS:
      case PROJECT_GROUP_TYPE_DP_TOK_ESSAY:
      case PROJECT_GROUP_TYPE_DP_TOK_EXHIBITION:
      case PROJECT_GROUP_TYPE_DP_EE:
      case PROJECT_GROUP_TYPE_PERSONAL:
      case PROJECT_GROUP_TYPE_COMMUNITY:
      case PROJECT_GROUP_TYPE_SERVICE_AS_ACTON:
      case PROJECT_GROUP_TYPE_DP_G4_PROJECT:
      case PROJECT_GROUP_TYPE_DP_COLLABORATIVE_SCIENCES_PROJECT:
      case PROJECT_GROUP_TYPE_CP_REFLECTIVE_PROJECT:
      case PROJECT_GROUP_TYPE_CP_SERVICE_LEARNING:
      case PROJECT_GROUP_TYPE_COMMUNITY_ENGAGEMENT: {
        dispatch(
          goToProjectFeatureRouteByProjectGroupType({
            projectGroupType: feature,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_SCHOOL_LIBRARY: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: `school-library`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_CURRICULUM_INSIGHTS: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: `curriculum-insights`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_CURRICULUM_MAPS: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: `curriculum-publishing`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_STUDENT_PLANS: {
        dispatch(
          goToPlatformHomeChildRoute({
            route: `student-plans`,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_OAUTH_LOGIN: {
        const userInfo = getUserInfo();
        const { org_id: organizationId } = userInfo;

        dispatch(
          authorizeUserWithOauth2({
            service: getOauthServiceName({ organizationId }),
          })
        );
        break;
      }

      case ESF_SENTRAL_WELLBEING:
      case ESF_SENTRAL_TIMETABLE:
      case ESF_SENTRAL_POLICIES:
      case ESF_SENTRAL_ATTENDANCE:
      case ESF_SENTRAL_PXP:
      case ESF_SENTRAL_NEWSFEED:
      case ESF_SENTRAL_DAILY_NOTICE: {
        dispatch(
          authorizeUserWithEsfSentral({
            feature,
            shouldRefetchQuery: isSentralNotificationActive,
          })
        );
        break;
      }

      case HOME_PAGE_FEATURE_PLANNING_INSIGHTS: {
        const currentCurriculumProgram = _.get(
          state,
          "platform.currentCurriculumProgram"
        );
        const curriculumProgramType = _.get(currentCurriculumProgram, "type");

        if (curriculumProgramType === "IB_DP") {
          dispatch(
            goToPlatformHomeChildRoute({
              route: "yearGroup",
            })
          );
        } else {
          dispatch(
            goToPlatformHomeChildRoute({
              route: "planningInsights",
            })
          );
        }
        break;
      }

      case HOME_PAGE_FEATURE_GRADEBOOK: {
        dispatch(goToPlatformHomeChildRoute({ route: "gradebook" }));
        break;
      }

      default: {
        console.error("No route found for this feature");
      }
    }
  };
};
